import AppConfig from "../../AppConfig";
import * as ACTIONTYPES from "../constants/actiontypes";
import {
  getActiveFrame,
  getAvailableNumberOfFrames,
  getBookType,
  getFullDuration,
  getIsDemo,
  getIsFree,
  getIsPlaying,
  getIsWidget,
  getPLAYER,
  getTimeCalculatedFromFrameNumber,
  getViewMode,
} from "../selectors/selectors";

import { hideControls } from "./controls-visibility-actions";

import {onClickFullscreen, toggleLoginPopup, togglePlay} from "./index";

import { currentTimeChange } from "./video-actions";

import { fetchWidget } from "./widget-actions";


export const setTimeFromCurrentState = () => (dispatch, getState) => {
  const state = getState();
  const bookType = getBookType(state);

  if (!AppConfig.BOOK_TYPE_MODES[bookType].includes("video")
  && !AppConfig.BOOK_TYPE_MODES[bookType].includes("audio")) {
    return;
  }

  const PLAYER = getPLAYER(state);
  const time = getTimeCalculatedFromFrameNumber(getState());

  if (Number.isFinite(+time)) {
    dispatch(currentTimeChange(time));
    PLAYER.seekTo(time);
  }
  // PLAYER.currentTime(time)
};

export const setAutoplay = (autoplay) => (dispatch, getState) => {
 const finalAutoplayValue = autoplay == true || autoplay == 'true';
  dispatch({
    type: ACTIONTYPES.SET_AUTOPLAY,
    autoplay: finalAutoplayValue,
  });
};

export const setWaitingForAction = (data) => (dispatch, getState) => {
  dispatch({
    type: ACTIONTYPES.SET_WAITING_FOR_ACTION,
    data: data,
  });
};

export const alreadyLogged = () => (dispatch, getState) => {
  dispatch({
    type: ACTIONTYPES.ALREADY_LOGGED,
  });
};

export const changeActiveFrame = frame => (dispatch, getState) => {
  const availableNumberOfFrames = getAvailableNumberOfFrames(getState());

  if (frame <= availableNumberOfFrames) {
    dispatch({
      type: ACTIONTYPES.CHANGE_ACTIVE_FRAME,
      activeFrame: frame,
    });
  } else {
    dispatch(bookEnded());
  }
};

export const setNextFrame = () => (dispatch, getState) => {
  const state = getState();
  const activeFrame = getActiveFrame(state);

  dispatch(changeActiveFrame(activeFrame === -1 ? 1 : activeFrame + 1));
  dispatch(setTimeFromCurrentState());
};

export const setPreviosFrame = () => (dispatch, getState) => {
  const activeFrame = getActiveFrame(getState());

  if (activeFrame > 0) {
    dispatch(changeActiveFrame(activeFrame - 1));
    dispatch(setTimeFromCurrentState());
  }
};

export const repeatCurrentFrame = () => (dispatch, getState) => {
  const state = getState();
  const isPlaying = getIsPlaying(state);
  dispatch(setTimeFromCurrentState());

  if (!isPlaying) {
    dispatch(togglePlay(true));
  }
};

export const videoSeekChange = (value) => (dispatch, getState) => {
  const state = getState();
  const fullDuration = getFullDuration(state);
  const PLAYER = getPLAYER(state);
  const time = fullDuration * value;

  dispatch(currentTimeChange(time));
  // PLAYER.currentTime(time)
  PLAYER.seekTo(time);
};

export const setVolume = volume => (dispatch, getState) => {

  dispatch({
    type: ACTIONTYPES.SET_VOLUME,
    volume,
  });
};

export const toggleSubtitilesVisibility = () => ({
  type: ACTIONTYPES.TOGGLE_SUBTITLES_VISIBILITY,
});

export const toggleBellPlay = () => (dispatch, getstate) => {

  dispatch({
    type: ACTIONTYPES.TOGGLE_BELL_PLAY,
  });

  setTimeout(() => {
    dispatch({
      type: ACTIONTYPES.TOGGLE_BELL_HINT,
    });
  }, 2000);
};

export const setFrameToView = frame => (dispatch, getState) => {
  dispatch(changeActiveFrame(frame));
  dispatch(setTimeFromCurrentState());
};


export const bookEnded = () => (dispatch, getState) => {
  const state = getState();
  const bookType = getBookType(state);
  const isWidget = getIsWidget(state);
  const isDemo = getIsDemo(state);
  const isFree = getIsFree(state);

  if (isDemo && !isFree) {
    if (state.videoPlayerState.alreadyLogged || state.book.isLogged) {
      dispatch(setFrameToView(0));

      let buyOrSubscribePopupEvent = new CustomEvent("buy_or_subscribe_popup_open", { detail: { ...state.book.bookInfo } });
      document.dispatchEvent(buyOrSubscribePopupEvent);
    } else {
      let loginPopupEvent = new Event("login_popup_open");
      document.dispatchEvent(loginPopupEvent);
    }
    if (AppConfig.BOOK_TYPE_MODES[bookType].includes("video")
    || AppConfig.BOOK_TYPE_MODES[bookType].includes("audio")) {
      dispatch(togglePlay(false));
    }
    dispatch(toggleLoginPopup(true));
    dispatch(hideControls());
    if (state.videoPlayerState.isFullscreen) dispatch(onClickFullscreen());
  }

  if (isWidget) {
    dispatch(fetchWidget());
    dispatch(startedWatch(false));
  }
};

export const startedWatch = (isStarted) => (dispatch, getState) => {
  const prevStateIsStarted = getState().videoPlayerState.isStarted;
  if (prevStateIsStarted !== isStarted) {
    dispatch({
      type: ACTIONTYPES.VIDEO_PLAYER_STARTED,
      isStarted,
    });
  }
};


export const toggleVideoPlayerReadyState = (action) => (dispatch, getState) => {
  dispatch({
    type: ACTIONTYPES.VIDEO_PLAYER_IS_READY,
    data: action,
  });
  window.addEventListener("message", (e) => {
    const isRead = getViewMode(getState()) === "text";
    switch (e.data) {
      case "play":
        if (!isRead) {
          dispatch(togglePlay(true));
          dispatch(startedWatch(true));
        }
        break;

      case "stop":
        dispatch(togglePlay(false));
        dispatch(startedWatch(false));
        break;

      case "full-screen":
        dispatch(onClickFullscreen());
        break;

      default:
        break;
    }
  }, false);
};



// WEBPACK FOOTER //
// ./src/store/actions/play-actions.js